export default "__VITE_ASSET__CCsk6qF___"